import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { INCIDENT_CATEGORY_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetActiveIncidentCategoryProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getActiveIncidentCategory = async (communityId: string) =>
  await axiosAuth.get(`${INCIDENT_CATEGORY_API(communityId)}/active`);

const useGetActiveIncidentCategory = ({
  communityId,
  queryParams,
}: UseGetActiveIncidentCategoryProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["incident-active-category", communityId],
    queryFn: () => getActiveIncidentCategory(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetActiveIncidentCategory;
